class FJPool {
    constructor() {
        this._maxCount = 50;
        this._list = []; // { value: any,  idle: boolean }
    }

    get size() {
        return this._list.length;
    }

    getItem(options) {
        queueMicrotask(() => this._checkAndFilterItems());
        const item = this._findIdleItem(options);
        if (item) {
            item.idle = false;
            return item.value;
        }
        const newItem = this._createItem(options);
        newItem.idle = false;
        this._list.push(newItem);
        return newItem.value;
    }

    releseItem(value) {
        if (!value) {
            return;
        }
        queueMicrotask(() => this._checkAndFilterItems());
        this._clearItem(value);
        const item = this._list.find(({ value: itemValue }) => value === itemValue);
        if (item) {
            item.idle = true;
        }
    }

    _findIdleItem() {
        return this._list.find(({ idle }) => idle);
    }

    // _clearItem(value) {}

    // _createItem(type, options) {}

    _checkAndFilterItems() {
        if (this._list.length > this._maxCount) {
            const filterItems = this._list.filter(({ idle }) => !idle);
            this._list.length = 0;
            this._list.push(...filterItems);
        }
    }
}

export default FJPool;
